import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, from, Observable } from 'rxjs';
import {
  FeatureFlag,
  FeatureFlagsConfig,
  FeatureFlagsCore,
  FeatureFlagsResponse,
} from '@portal-front/feature-flags/core';
import { AngularHttpAdapter } from '../adapters/angular-http.adapter';
import { FF_SERVICE } from '../tokens/feature-flags.tokens';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  private readonly core: FeatureFlagsCore;
  private flagsSubject = new BehaviorSubject<FeatureFlagsResponse>({});
  public flags$ = this.flagsSubject.asObservable();

  constructor(
    private httpAdapter: AngularHttpAdapter,
    @Inject(FF_SERVICE) config: FeatureFlagsConfig,
  ) {
    this.core = new FeatureFlagsCore(this.httpAdapter, config);
  }

  loadFeatureFlags(): Observable<FeatureFlagsResponse> {
    return from(
      this.core.loadFeatureFlags().then((flags) => {
        this.flagsSubject.next(flags);
        return flags;
      }),
    );
  }

  isFeatureEnabled(flagName: string, context?: Record<string, unknown>): boolean {
    return this.core.isFeatureEnabled(flagName, context);
  }

  getFeatureFlag(flagName: string): FeatureFlag | undefined {
    return this.core.getFeatureFlag(flagName);
  }
}
